import { navigatorLock, processLock } from "@supabase/supabase-js";

/** Some private/embedded browsers expose navigator.locks but deny its use. */
export async function storageSafeAuthLock<R>(
  name: string,
  timeout: number,
  fn: () => Promise<R>,
): Promise<R> {
  let callbackStarted = false;
  const run = async () => {
    callbackStarted = true;
    return fn();
  };
  try {
    if (typeof navigator === "undefined" || !navigator.locks)
      return await processLock(name, timeout, run);
    return await navigatorLock(name, timeout, run);
  } catch (error) {
    // Only retry a denied lock acquisition. Re-running a callback after it
    // began can duplicate refreshes or actions; acquisition timeouts stay errors.
    if (
      !callbackStarted &&
      error &&
      typeof error === "object" &&
      "name" in error &&
      error.name === "SecurityError"
    ) {
      return processLock(name, timeout, run);
    }
    throw error;
  }
}
